// extracted by mini-css-extract-plugin
export default {"radio-item":"radio-item_radio-item__6W4cA","top":"radio-item_top__oDW+J","text":"radio-item_text__89sz4","content":"radio-item_content__sqjkO"};